import PropTypes from "prop-types";

import { useShowACHModal } from "Giving/ManageMyGivingPage/stateHooks/useShowACHModal";
import { useShowCCModal } from "Giving/ManageMyGivingPage/stateHooks/useShowCCModal";
import { alertTypes } from "Giving/constants";

import FnrButton3 from "UI/FnrButton3";

// import { useOpenModal } from "./hooks/actionHooks";

const AlertButton = ({ alertType, url, color, setActiveAlertID, ...props }) => {
  let buttonText = "";
  let buttonAction = () => {};
  // const openModal = useOpenModal();
  const [, setShowACHModal] = useShowACHModal();
  const [, setShowCCModal] = useShowCCModal();

  switch (alertType) {
    case alertTypes.WEPAY_CC_ALERT:
      buttonText = "Update Card Info";
      buttonAction = () => {
        setShowCCModal(true);
        setActiveAlertID();
      };
      break;
    case alertTypes.WEPAY_ACH_ALERT:
      buttonText = "Update Bank Info";
      buttonAction = () => {
        setActiveAlertID();
        setShowACHModal(true);
      };
      break;
    case alertTypes.PLEDGE_PAYMENT_ALERT:
      buttonText = "Set Up a Recurring Gift";
      buttonAction = () => {
        window.open(url, "_blank");
      };
      break;

    case alertTypes.PLEDGE_BEHIND_ALERT:
      buttonText = "Make a Gift to Catch Up";
      buttonAction = () => {
        window.open(url, "_blank");
      };
      break;
    default:
      break;
  }
  return buttonText && buttonAction ? (
    <FnrButton3
      color={color || "blue"}
      onClick={buttonAction}
      style={{ maxHeight: "50px", flexShrink: 0 }}
      {...props}
    >
      {buttonText}
    </FnrButton3>
  ) : null;
};

AlertButton.propTypes = {
  alertType: PropTypes.string,
  url: PropTypes.string,
  color: PropTypes.string,
  setActiveAlertID: PropTypes.func,
};

export default AlertButton;
